export default __webpack_public_path__ + "static/media/airbattle_arcade.280e82ad.gif";